import * as Cookie from '../../cookie/cookie';

export function embedderIsEnabled( key: string ): boolean {
	const match = document.cookie.match( new RegExp( '(^| )mr_prv_embedders=([^;]+)' ) );
	let records: Array<{ key: string, value: string }> = [];
	if ( match && match[2] ) {
		records = Cookie.unpackRecords( match[2] );
	}

	records = records.filter( ( record ) => {
		return record.key === key && '1' === record.value;
	} );

	return 0 < records.length;
}

export function enableEmbedder( key: string ): void {
	const match = document.cookie.match( new RegExp( '(^| )mr_prv_embedders=([^;]+)' ) );
	let records: Array<{ key: string, value: string }> = [];
	if ( match && match[2] ) {
		records = Cookie.unpackRecords( match[2] );
	}

	records = records.filter( ( record ) => {
		return record.key !== key;
	} );

	records.push( {
		key: key,
		value: '1',
	} );

	const expires = window.Mr_Prv_Embedder_Helpers.cookieExpiration();

	if ( window.Mr_Prv_Embedder_Helpers.cookieDomain() ) {
		document.cookie = `mr_prv_embedders=${Cookie.packRecords( records )}; domain=${window.Mr_Prv_Embedder_Helpers.cookieDomain()}; path=/; secure; samesite=lax; expires=` + expires.toUTCString();
	} else {
		document.cookie = `mr_prv_embedders=${Cookie.packRecords( records )}; path=/; secure; samesite=lax; expires=` + expires.toUTCString();
	}
}

export function disableEmbedder( key: string ): void {
	const match = document.cookie.match( new RegExp( '(^| )mr_prv_embedders=([^;]+)' ) );
	let records: Array<{ key: string, value: string }> = [];
	if ( match && match[2] ) {
		records = Cookie.unpackRecords( match[2] );
	}

	records = records.filter( ( record ) => {
		return record.key !== key;
	} );

	records.push( {
		key: key,
		value: '-1',
	} );

	const expires = window.Mr_Prv_Embedder_Helpers.cookieExpiration();

	if ( window.Mr_Prv_Embedder_Helpers.cookieDomain() ) {
		document.cookie = `mr_prv_embedders=${Cookie.packRecords( records )}; domain=${window.Mr_Prv_Embedder_Helpers.cookieDomain()}; path=/; secure; samesite=lax; expires=` + expires.toUTCString();
	} else {
		document.cookie = `mr_prv_embedders=${Cookie.packRecords( records )}; path=/; secure; samesite=lax; expires=` + expires.toUTCString();
	}
}
